import { getAPI } from 'src/utils/api';

import { notification } from 'antd';
import i18n from 'i18next';

import checkAuthError from '../utils/checkAuthError';

notification.config({
	placement: 'topRight',
	top: 75,
	duration: 2,
});

const addGroup = async (name, users, models, ldap) => {
	try {
		const api = await getAPI();
		const { data } = await api.post('/group/', {
			name,
			users,
			ldap,
			modelAccess: models,
		});

		notification.success({
			message: i18n.t('groupView.newMsg'),
			description: i18n.t('groupView.saveMsg'),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.log(error.response);
	}
};
const getAllGroups = async () => {
	try {
		const api = await getAPI();
		const { data } = await api.get('/group/all');
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
};
const updateGroup = async (values) => {
	try {
		const api = await getAPI();
		const { data } = await api.put(`/group/${values._id}/`, {
			values,
		});

		notification.success({
			message: i18n.t('groupView.updateMsg'),
			description: i18n.t('groupView.saveMsg'),
		});
		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.log(error.response);
	}
};
const deleteGroup = async (groupId) => {
	try {
		const api = await getAPI();
		const { data } = await api.delete(`/group/${groupId}`);
		notification.success({
			message: i18n.t('groupView.deleteMsg'),
		});

		return data;
	} catch (error) {
		checkAuthError(error);

		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.log(error.response);
	}
};

const queryWindowsGroups = async (query) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`group/ldapall?query=${query}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.log(error.response);
	}
};

export { addGroup, getAllGroups, updateGroup, deleteGroup, queryWindowsGroups };
